import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-lead-time-chart',
  imports: [],
  templateUrl: './lead-time-chart.component.html',
  styleUrl: './lead-time-chart.component.scss'
})
export class LeadTimeChartComponent implements OnChanges {
  @Input() data: any;
  @Input() id: any;
  @Input() Title: any;
  private chart: Chart | undefined;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.updateChart();
    }
  }

  ngAfterViewInit() {
    this.updateChart();
  }

  updateChart() {
    const analysis_daily_opt: any = document.getElementById("canvas__" + this.id);
    if (!analysis_daily_opt) return;
    
    const analysis_daily_ctx = analysis_daily_opt.getContext('2d');

    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy();
    }

    var _labels = [];
    var values = [];
    if (this.data) {
      for (var key in this.data) {
        _labels.push(key);
        values.push(this.data[key])
      }
    }

    this.chart = new Chart(analysis_daily_ctx, {
      type: 'line',
      data: {
        labels: _labels,
        datasets: [{
          data: values,
          pointRadius: 3,
          pointHoverRadius: 5,
          borderWidth: 3,
          borderColor: '#F0950C',
          backgroundColor: 'rgba(240, 149, 12, 0.1)',
        }]
      },

      options: {
        animation: {
          duration: 1,
          onComplete: function ({ chart }) {
            const ctx = chart.ctx;

            chart.config.data.datasets.forEach(function (dataset, i) {
              const meta = chart.getDatasetMeta(i);

              meta.data.forEach(function (bar, index) {
                const data: any = dataset.data[index];
                console.log(data)

                // ctx.fillText(data, bar.x, bar.y - 5);
              });
            });
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        },
        scales: {
          y: {
            grid: { display: true }
          },
          x: {
            grid: { display: true }
          }
        }

      },
    })

  }
}
